export const appTypo = {
  font: {
    kintoSans: "kinto-sans",
    notoJp: "Noto Sans JP, sans-serif",
    roboto: "Roboto, sans-serif",
  },
} as const;
